import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

const sliderNode = document.querySelector<HTMLElement>('.slider')

if (sliderNode) {
  const slider = EmblaCarousel(sliderNode, { loop: true }, [
    Autoplay({ delay: 10000, stopOnInteraction: true, stopOnFocusIn: true })
  ])

  const slides = sliderNode.querySelectorAll<HTMLElement>('.slider__slide')
  if (slides) {
    slides.item(0).classList.add("current")
    
    slider.on("select", () => {
      slides.forEach((slide) => slide.classList.remove("current"))
      slides.item(slider.selectedScrollSnap()).classList.add("current")
    })
  }

  const buttons = sliderNode.querySelectorAll<HTMLButtonElement>('.slider__buttons button')
  if (buttons) {
    buttons.item(0).classList.add("current")

    slider.on("select", () => {
      buttons.forEach((button) => button.classList.remove("current"))
      buttons.item(slider.selectedScrollSnap()).classList.add("current")
    })

    // @ts-ignore
    slider.on('autoplay:stop', () => {
      sliderNode.classList.add('stopped')
    })

    // @ts-ignore
    slider.on('autoplay:play', () => {
      sliderNode.classList.remove('stopped')
    })

    buttons.forEach((button, i) => {
      button.addEventListener("click", ()=> {
        slider.scrollTo(i)
      })
    })
  }
}
